import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { scroller } from 'react-scroll';
import { selectScrollTo } from 'shared/selectors/selectScrollTo';

export const useToScroll = () => {
  const scrollTo = useSelector(selectScrollTo);

  useEffect(() => {
    if (scrollTo) {
      scroller.scrollTo(scrollTo, {
        delay: 100,
        smooth: true,
        offset: -200,
      });
    }
  }, [scrollTo]);
};
